export class FileProgress {
    constructor(public requestId: string, public loaded: number, public total: number) {
    }

    public get progressPercent(): number {
        return 100 * (this.loaded / this.total);
    }
}